import { render, staticRenderFns } from "./notfound.vue?vue&type=template&id=0a7bb0ee&scoped=true"
import script from "./notfound.vue?vue&type=script&lang=js"
export * from "./notfound.vue?vue&type=script&lang=js"
import style0 from "./notfound.vue?vue&type=style&index=0&id=0a7bb0ee&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7bb0ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a7bb0ee')) {
      api.createRecord('0a7bb0ee', component.options)
    } else {
      api.reload('0a7bb0ee', component.options)
    }
    module.hot.accept("./notfound.vue?vue&type=template&id=0a7bb0ee&scoped=true", function () {
      api.rerender('0a7bb0ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/notfound.vue"
export default component.exports